module.exports = __webpack_public_path__ + "fontoctopus.8acc0c7e45d7d6f690a7342d70180835.hashedasset.woff";


//////////////////
// WEBPACK FOOTER
// ./app/resources/fonts/fontoctopus/fontoctopus.woff
// module id = 439
// module chunks = 8